import { Fragment, useState } from 'react';
import styles from './paginator.module.css'
export default function Paginator (props: {totalRows: number, setPage: any, page: number}) {
	const {totalRows} = props;
	return (
			<div className={styles.container}>
			<button 
				className={styles.paginationBtn}
				style={{visibility: props.page === 1 ? 'hidden' : 'visible'}}
				disabled={props.page === 1}
				onClick={() => {
				window.scrollTo(0,0);
				props.setPage(props.page - 1);}
				}><Fragment>&lt;&lt; </Fragment></button>
			<div>
				{Math.round(totalRows / 25) > 0 ? <div style={{fontWeight: 600, fontSize: '14px'}}>Side {props.page} av {Math.round(totalRows / 25)}</div> : <></>}
				<div style={{marginTop: '8px'}}>{
					Array.from(Array(Math.round(totalRows / 25)).keys())
					.map((r,index) => {
						return (
						<div key={`page${index+1}`} className={`${styles.pageBtn} ${props.page == (r+1) ? styles.pageBtnSelected : ''}`}
						onClick={(e) => {
							window.scrollTo(0,0);
							props.setPage(Number(e.currentTarget.innerText));
						}}>{(r+1)}</div>)
					})}
				</div>
			</div>							
			<button 
				style={{visibility: props.page === Math.round(totalRows / 25) ? 'hidden' : 'visible'}}
				className={styles.paginationBtn}
				disabled={props.page === Math.round(totalRows / 25)}
				onClick={() => {window.scrollTo(0,0);props.setPage(props.page + 1);
			}}><Fragment>&gt;&gt;</Fragment></button>	
			</div>

	)
}